import "./ContactUs.scss"
import Header from 'modules/Shared/components/Header/Header';
import Footer from 'modules/Shared/components/Footer/Footer';
import React, { useState, useRef, useEffect } from "react";
import { IContactUsModel, ResponseModel } from 'models/api.data.model';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { isEmailValid } from 'data/common.data';
import { UtilAPI } from 'services/util.service';
import PhoneInput, { CountryData } from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
interface ICheckBoxData {
    termsContact: boolean,
    termsPrivacy: boolean
}

const ContactUs = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const formRef = useRef<any>(null);
    const DEFAULT_CONTACTUS_DATA: IContactUsModel = { name: '', companyName: '', mail: '', phone: '', message: '', info: window.location.href };
    const DEFAULT_CHECKBOX_DATA: ICheckBoxData = { termsContact: false, termsPrivacy: false };
    const contentData: string = 'contact Us';
    const [contactData, setContactData] = useState<IContactUsModel>({ ...DEFAULT_CONTACTUS_DATA });
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [phoneNumber, setPhoneNumber] = useState<string>('');
    const PHONE_REGEX: RegExp = /^[1-9]\d{4,14}$/;
    const [checkboxData, setCheckboxData] = useState<ICheckBoxData>({ ...DEFAULT_CHECKBOX_DATA });

    const checkPhoneVaildity = (inputPhone: string) => {
        console.log(PHONE_REGEX.test(inputPhone));
        return PHONE_REGEX.test(inputPhone);
    }

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = e.target;
        setCheckboxData({ ...checkboxData, [name]: checked })
    };

    const handleFormChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setContactData({ ...contactData, [name]: value });
    }
    const handlePhoneNumberChange = (value: string, country: CountryData) => {
        const data: IContactUsModel = { ...contactData };
        data.phone = `${country.dialCode}-${value.substring(country.dialCode?.length)}`;
        setContactData(data);
        setPhoneNumber(value);
    };

    const doSubmit = (e: any) => {
        e.preventDefault();
        if (!contactData.name.trim() || !contactData.mail.trim() || !contactData.message.trim()) {
            toast.error('Please fill out all mandatory fields.');
            return;
        }
        if (!isEmailValid(contactData.mail)) {
            toast.error('Please enter a valid email address.');
            return;
        }
        if (!checkboxData.termsPrivacy) {
            toast.error('Please check privacy policy');
            return;
        }
        setIsLoading(true);
        UtilAPI.submitContactUs(contactData)
            .then((res: ResponseModel) => {
                setIsLoading(false);
                if (res.status) {
                    resetContact();
                    toast.success("You have submitted information successfully. We'll contact you shortly.");
                } else {
                    console.warn(res);
                    toast.error('Failed to submit contact details. Response status is false.');
                }
            })
            .catch((err: any) => {
                setIsLoading(false);
                console.error(err);
                toast.error('Failed to submit contact details. Error.');
            });
    }


    const resetContact = () => {
        setContactData({ ...DEFAULT_CONTACTUS_DATA });
        formRef.current.reset();
        setCheckboxData({ ...DEFAULT_CHECKBOX_DATA });
        setPhoneNumber('');
    }
    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>Airlegit | Contact US</title>
                    <meta name='description' content={contentData} />
                </Helmet>
            </HelmetProvider>
            <ToastContainer theme='colored' />
            <Header />
            <div className="login-container full-height">
                <div className="container-content-padding container-small-width">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">

                                <form id='login-form' ref={formRef} noValidate>
                                    <h2 className="form-header">
                                        CONTACT US
                                    </h2>
                                    <div className="sub-header">We'd love to hear from you. Tell us what you need and we'll get back to you as soon as possible:</div>
                                    <div className="form-notes">Required fields are marked by an asterisk (<span className='text-error'>*</span>)</div>

                                    <div className='cust-form-group'>
                                        <label htmlFor='first-Name'>Full Name<b className='text-error'>*</b></label>
                                        <input name='name' type='text' id='fullName' onChange={handleFormChange} value={contactData.name} required />
                                    </div>
                                    <div className='cust-form-group'>
                                        <label htmlFor='company-Name'>Company Name</label>
                                        <input name='companyName' type='text' id='companyName' onChange={handleFormChange} value={contactData.companyName} required />
                                    </div>
                                    <div className='cust-form-group'>
                                        <label htmlFor='email'>Work Email Address<b className='text-error'>*</b></label>
                                        <input name='mail' type='text' id='mail' onChange={handleFormChange} value={contactData.mail} required />
                                    </div>

                                    <div className='cust-form-group' style={{ marginBottom: '15px' }}>
                                        <label htmlFor='phone-Number'>Phone Number</label>
                                        <PhoneInput
                                            country={'us'}
                                            value={phoneNumber}
                                            onChange={(value: string, country: CountryData) => handlePhoneNumberChange(value, country)}
                                        />
                                    </div>

                                    <div className='cust-form-group'>
                                        <label htmlFor='description'>Tell us about your needs <b className='text-error'>*</b></label>
                                        <textarea name="message" id='description' required rows={4} value={contactData.message} onChange={handleFormChange}></textarea>
                                    </div>

                                    <div>
                                        <input type="checkbox" className="termsandconditioncheckBox" id="termscontact" name="termsContact" checked={checkboxData.termsContact} onChange={handleCheckboxChange} />
                                        <label htmlFor="terms-Contact" className="termsandconditionText" >I agree to receive communication from Airlegit</label>
                                    </div>

                                    <div>
                                        <input type="checkbox" className="termsandconditioncheckBox" id="termsprivacy" name="termsPrivacy" checked={checkboxData.termsPrivacy} onChange={handleCheckboxChange} />
                                        <label htmlFor="terms-Privacy" className="termsandconditionText" >I agree to Airlegit's <a href="https://airlegit.com/privacy" target="_blanck">Privacy Policy</a>
                                            <span className='text-error'>*</span></label>
                                    </div>


                                    <div className='cust-form-group button-wrapper'>
                                        <button type='button' id='submit' onClick={doSubmit} className='btn-primary'>
                                            Submit
                                        </button>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default ContactUs;